<template>
  <div style="overflow: hidden;" v-if="current.indexOf('首页') > -1">
    <div class="bannerBox">
      <a-carousel :dot-position="bottom" autoplay>
        <div class="bannerImg" v-for="(item, index) in bannerData" :key="index">
          <img :src="getImg(item.imageUrl)" />
        </div>
      </a-carousel>
    </div>
    <div class="cont_body" style="margin-top:20px">
      <div class="industrialContentleft" style="margin-left:20px">
        <div class="industrialTitleBox">
          <div class="industrialTitle">
            通知公告
          </div>
          <div class="MoreBox" @click="goMore('/knowledge/law', '通知公告')">
            更多 ></div>
        </div>
        <a-list size="large" :data-source="policyData">
          <template #renderItem="{ item }">
            <a-list-item @click="onpolicyDetail(item.id)">
              <div class="left">
                <span>{{ item.title }}</span>
              </div>
              <div class="right">
                <span> {{ item.publishTime ? item.publishTime.split(' ')[0] : '' }} </span>
              </div>
            </a-list-item>
          </template>
        </a-list>
      </div>
      <div class="industrialContentRight">
        <div @click="goMore('/knowledge/popularScience', '知识产权申报', 's')" class="rightItem">知识产权申报</div>
        <div @click="goMore('/knowledge/popularScience', '知识产权预审', 'y')" class="rightItem">知识产权预审</div>
        <div @click="goMore('/knowledge/popularScience', '地理标志证明商标集体商标', 'd')" class="rightItem">地理标志证明商标集体商标</div>
        <div @click="goMore('/knowledge/popularScience', '山西“晋心办”商标品牌指导站', 'j')" class="rightItem">山西“晋心办”商标品牌指导站</div>
        <div @click="goMore('/knowledge/popularScience', '商标申请', 'q')" class="rightItem">商标申请</div>
        <div @click="goMore('/knowledge/popularScience', '知识产权质押融资', 'r')" class="rightItem">知识产权质押融资</div>
        
      </div>
    </div>
    <div class="cont_body rightTextflex" style="margin-top:20px">
      <div class="rightText">知识产权数量：<span style="color: #b95e22;">{{ fourObj.intellectualPropertyCount }}</span> 件</div>

      <div class="rightText">发明专利数量：<span style="color: #f8c880;">{{ fourObj.inventionPatentNumberCount }}</span> 家</div>

      <div class="rightText">实用新型专利数量：<span style="color: #94f880;">{{ fourObj.newSoftwareLicenseNumberCount }}</span> 家
      </div>

      <div class="rightText">软件著作权数量：<span style="color: #80d2f8;">{{ fourObj.newSoftwareLicenseNumberCount }}</span> 家
      </div>

      <div class="rightText">其他专利：<span style="color: #9f80f8;">{{ fourObj.pctPatentLicensingCount }}</span> 家</div>

    </div>


    <div class="cont_body" style="margin-top:20px">
      <div v-if="loopData" class="bannerBox">
        <a-carousel v-if="loopData.length" dots="false" arrows autoplay :slides-to-show="loopData.length > 5 ? 5 : loopData.length"
          :slides-to-scroll="1">
          <template #prevArrow>
            <div class="custom-slick-arrow" style="left: 10px;top:35%">
              <LeftCircleOutlined />
            </div>
          </template>
          <template #nextArrow>
            <div class="custom-slick-arrow" style="right: 10px;top:35%">
              <RightCircleOutlined />
            </div>
          </template>
          <div class="bannerImg zcloop" v-for="(item, index) in loopData" :key="index">
            <img @click="goMore('/knowledge/zcloop', '知识产权轮播', item.id)" :src="getImg(item.thumbnail)" />
            <p style="color:#000;text-align: center;margin-top:20px">{{ item.title }}</p>
          </div>
        </a-carousel>
      </div>
    </div>


    <!-- <div class="cont_body" style="margin-top:20px">
					<div class="body_img">
						<img src="../img/bqjy.jpg" />
            <div class="body_img_btn red" style="bottom:40px" @click="goMore('/knowledge/investor','知识产权交易')">查看更多
              <ArrowRightOutlined style="font-weight:600;margin-left:15px" /></div>
			
					</div>
					<div class="body_cont">
							
							<div v-for="(item,key) in optionsData" :key="key" @click="goMore('/knowledge/investor/page','知识产权交易',item.id)" class="list_cont list_cont_bq" style="height:294px">
								<div>
									<div class="list_img_bq">
										<img :src="getImg(item.knowledgeCopyright.icon)" alt="">
									</div>
									<h4>{{ item.propertyNames }}</h4>
								</div>
								<div class="list_cont_body_bq">
									
									<P>分类：
										<dict-render :dict-obj="dictObjs['projectType']"
										:text="item.knowledgeCopyright.copyrightType"></dict-render>
									</P>
									<p>
										适用范围：<dict-render :dict-obj="dictObjs['copyright_scope']"
										:text="item.knowledgeCopyright.copyrightRange"></dict-render>
									</p>
                  <h3 v-if="item.priceType=='0'">
                    {{item.price}}<span>元</span>
                  </h3>
                  <h3 v-else>
                    面议
                  </h3>
			
									<a-button>咨询购买</a-button>
								</div>
							</div>
							</div>
							</div> -->
    <div class="cont_body">
      <div class="body_img">
        <img src="../img/jyzr.jpg" />
        <div class="body_img_btn red" style="bottom:40px" @click="goMore('/knowledge/zclooplist', '知识产权转让')">查看更多
          <ArrowRightOutlined style="font-weight:600;margin-left:15px" />
        </div>

      </div>
      <div class="body_cont">
        <div>
          <div v-for="(item, key) in loopData2" :key="key" @click="goMore('/knowledge/zcloop', '知识产权转让', item.id)"
            class="list_cont list_cont_zl">
            <div>
              <div class="list_img_zl">
                <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="">
                <img v-else src="@/assets/img/defaultPhoto.png" alt="">
              </div>
            </div>
            <div class="list_cont_body_zl">
              <h4>{{ item.title }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cont_body">
      <div class="body_img">
        <img src="../img/jyxq.jpg" />
        <div class="body_img_btn blue" style="bottom:40px" @click="goMore('/knowledge/need', '知识产权需求')">查看更多
          <ArrowRightOutlined style="font-weight:600;margin-left:15px" />
        </div>

      </div>
      <div class="body_cont">
        <div>
          <div v-for="(item, key) in loopData3" :key="key" @click="goMore('/knowledge/need/page', '知识产权需求', item.id)"
            class="list_cont list_cont_zl" style="height:293px;">
            <div>
              <div class="list_img_zl">
                <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="">
                <img v-else src="@/assets/img/defaultPhoto.png" alt="">
              </div>
            </div>
            <div class="list_cont_body_zl">
              <h4>{{ item.needName }}</h4>
            </div>
            <div class="list_cont_body_p">
              <p v-html="item.needBody"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="tabBox">
					<div class="activeLeftImg">
						<img src="../img/zcpx.jpg" alt="">
            <div class="body_img_btn blue" style="bottom:40px" @click="goMore('/knowledge/video','知识产权培训')">查看更多
              <ArrowRightOutlined style="font-weight:600;margin-left:15px" /></div>
					</div>
					<div class="activityContent">
						<div class="activityLi" style="height:294px" v-for="item in basicsCourseInfoWeb" :key="item.key" @click="onActivity(item.id)">
							<div class="activityImg">
								<img style="width: 100%;height: 100%;" :src="getImg(item.logo)" />
							</div>
							<div class="activityInfoTime">
								{{momentFormat(item.createdTime,'YYYY-MM-DD')}} <span>{{ item.frequency }}</span>  
							</div>
							<div class="activityInfoTitle">
								{{ item.name }}
							</div>
						</div>
					</div>
				</div> -->
  </div>
</template>
<script>
import { ArrowRightOutlined } from "@ant-design/icons-vue";
import { platformName } from "@/config/platformConfig";
import { knowledgePropertyTransactionWeb } from "@/api/knowledge";
import { basicsEssayInfoweb, basicsNeedInfo } from "@/api/finance";
import { dictMixin } from "@/mixins";
// import DictRender from "@/components/other/DictRender";
import { file_service } from "@/api/adminService";
import { basicsCourseInfoWeb } from "@/api/finance";
import { getBannerInfo } from "@/api/homeService";
import { noticeInfo } from "@/api/homeService";
export default {
  name: "index",
  components: {
    // DictRender,
    ArrowRightOutlined
  },
  mixins: [dictMixin],
  data() {
    return {
      dictNames: 'position,invest_limits,projectType,copyright_scope,tradeMode',
      platformName,
      optionsData: null,
      optionsDatas: null,
      basicsCourseInfoWeb: null,
      InvestorData: [],
      MechanisData: [],
      productData: [],
      current: ['首页'],
      clickMenuTitle: '',
      fourObj: {},
      formState: {
        user: null,
      },
      formSearchBox: {
        city: null,
        company: null,
        project: null,
        demand: null
      },
      screenWidth: null,
      bannerData: []
    }
  },
  mounted() {
    this.getFourData()
    this.getNoticeData()
    this.getSerchData()
    this.getBannerList()
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },

  watch: {
    screenWidth: function (n) {
      if (n <= 1200) {
        // console.log('屏幕宽度小于1200了')
      } else {
        // console.log('屏幕宽度没有小于1200')
      }
    }
  },
  methods: {
    getFourData() {
      this.getAction({
        url: noticeInfo.fourData,
      }).then(res => {
        // console.log(res)
        this.fourObj = res
      })
    },
    //通知公告
    onpolicyDetail(id) {
      this.$router.push({
        path: "/knowledge/law/page",
        query: { id: id, type: "通知公告" }
      })
    },
    getNoticeData() {
      this.getAction({
        url: basicsEssayInfoweb.pageList,
        params: {
          systemType: 'knowledge', type: '1',
          // pageSize:'2'
        }
      }).then(res => {
        this.policyData = res.records
      })

      this.getAction({
        url: basicsEssayInfoweb.pageList,
        params: {
          systemType: 'knowledge', type: 'l',
          // pageSize:'2'
        }
      }).then(res => {
        this.loopData = res.records
      })

      this.getAction({
        url: basicsEssayInfoweb.pageList,
        params: {
          systemType: 'knowledge', type: 'l',
          pageSize: '4'
        }
      }).then(res => {
        this.loopData2 = res.records
      })

      this.getAction({
        url: basicsNeedInfo.pageList,
        params: {
          needType: this.demand_types,
          moduleType: '5',
          systemType: 'knowledge',
          pageSize: '4'
        }
      }).then(res => {
        this.loopData3 = res.records
      })


    },
    onActivity(id) {
      this.$router.push({
        path: "/knowledge/video/Detail",
        query: { id: id, type: "知识产权培训" }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    getSerchData() {
      this.getAction({
        url: knowledgePropertyTransactionWeb.pageList,
        params: {
          pageNum: 1,
          pageSize: 4,
          propertyType: '3',//1专利2商标3版权
          // investmentField: this.investmentFields,
          // quota: this.invest_limits
        },
      }).then(res => {
        this.optionsData = res.records
      })
      this.getAction({
        url: knowledgePropertyTransactionWeb.pageList,
        params: {
          pageNum: 1,
          pageSize: 4,
          propertyType: '1',//1专利2商标3版权
          // investmentField: this.investmentFields,
          // quota: this.invest_limits
        },
      }).then(res => {
        this.optionsDatas = res.records
      })


      this.getAction({
        url: basicsCourseInfoWeb.pageList,
        params: {
          pageNum: 1,
          pageSize: 4,
          systemType: 'knowledge'
        },
      }).then(res => {
        this.basicsCourseInfoWeb = res.records
      })

    },
    goMore(url, key, id) {
      this.$router.push({
        path: url,
        query: { type: key, queryData: id }
      })
    },
    goMorezl(url, key, zl) {
      this.$router.push({
        path: url,
        query: { type: key, zlData: zl }
      })
    },
    menuClick(e) {
      this.clickMenuTitle = e.item.title
    },
    backhome() {
      this.$router.push('/')
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: 'knowledge' }
      }).then(res => {
        this.bannerData = res.records.reverse()
      })
    },
  }
}
</script>

<style scoped lang="less">
@import "../css/main.less";
@import "../css/components.less";

.zcloop {
  width: 200px !important;
  margin: 0 20px;

  img {

    height: 200px !important;
  }
}

.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 25px;
  height: 25px;
  font-size: 25px;
  z-index: 9;
  border-radius: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 1;
}

.rightTextflex {
  display: flex;

  .rightText {
    flex: 1;
    text-align: center;
    margin-left: 5px;
    line-height: 46px;

    span {
      font-size: 24px;
      color: #0048c4;
    }
  }
}

.industrialContentleft {
  position: relative;
  // overflow: hidden;
  float: left;
  width: 50%;
  color: #333;
  height: 226px;

  .industrialTitleBox {
    overflow: hidden;
    width: 100%;
    border-bottom: 1px solid #dedede;

    .industrialTitle {
      float: left;
      font-size: 20px;
      color: #333;
      padding-bottom: 5px;
    }

    .industrialTitle::before {
      content: '';
      padding-left: 12px;
      border-left: 4px solid #fc550b;
    }

    .MoreBox {
      float: right;
      color: #999;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .industrialContentTitle {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .industrialContentDesc {
    margin: 8px 0;
    font-size: 18px;
  }

  .industrialContentInfo {
    margin: 8px 0 40px 0;
    font-size: 14px;
    color: #666;
  }

  .industrialContentBtn {
    width: 120px;
    height: 35px;
    z-index: 999;

    .btn {
      width: 100%;
      height: 100%;
    }
  }

  :deep(.ant-list-lg .ant-list-item) {
    padding: 16px 0;
    cursor: pointer;
  }

  .left {
    width: 84%;
    float: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .right {
    float: right;
  }

  a {
    color: #000;
  }

  .ant-list-item:hover {
    color: #0a2c83;
  }

  .ant-list-item .right:hover {
    color: #0a2c83;
  }
}

.industrialContentRight {
  grid-column-gap: 20px;
  position: relative;
  // overflow: hidden;
  float: right;
  width: 50%;
  color: #333;
  height: 226px;
  display: grid;
  grid-template-columns: auto auto;
  padding: 10px 10px 10px 20px;

  .rightItem {
    cursor: pointer;
    padding: 10px;
    color: #fff;
    font-weight: bold;
    margin-bottom: 20px;
    background: #ff9100;
    font-size: 18px;
    text-align: center;

    &:hover {
      box-shadow: 1px 1px 10px 1px #666;
    }

    &:nth-child(1) {
      background: #00b7ff;
    }
    &:nth-child(3) {
      background: #00811c;
    }
    &:nth-child(4) {
      background: #97029c;
    }
    &:nth-child(5) {
      background: #8a1101;
    }
    &:nth-child(6) {
      background: #015e75;
    }
  }
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
  border-bottom: 3px solid #1890ff
}

:deep(.ant-menu-item-selected) {
  font-weight: 600;
}

:deep(.ant-btn) {
  border-radius: 0;
}

.cont_body {
  width: 1200px;
  margin: 0 auto 20px;

  .body_img {
    position: relative;

    .body_img_btn {
      cursor: pointer;
      position: absolute;
      bottom: 20px;
      left: 15%;
      font-size: 13px;
      color: #ffffff;
      font-weight: 600;
      padding: 10px 20px;
      border: 2px solid rgba(0, 0, 0, 0);

      &:hover {
        border: 2px solid #ffffff;
        transition: all 0.3s ease 0s;
      }


    }

    .red {
      background: #f34949;
    }

    .porpo {
      background: #616aeb;
    }

    .blue {
      background: #2fb5f4;
    }
  }

}

.list_cont_bq {
  width: 238px;
  display: block !important;
  margin-bottom: 16px;
  margin-right: 16px;

  &:nth-child(4n) {
    margin-right: 0
  }

  h4 {
    line-height: 100px;
  }

  .list_img_bq {
    width: 80px;
    float: left;
    height: 80px;
    overflow: hidden;
    border: 1px solid #eeeeee;
    margin: 16px;
    flex: 1;
    display: flex;
    align-items: center;

    img {
      width: 100%
    }
  }

  .list_cont_body_bq {
    flex: 5;
    clear: both;
    padding: 0 16px;
    padding-bottom: 16px;

    p {
      height: 20px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;

    }

    h3 {
      line-height: 60px;
      color: #ff9b18;

      span {
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}

.list_cont_zl {
  width: 238px;
  display: block !important;
  margin-bottom: 16px;
  margin-right: 16px;

  &:nth-child(4n) {
    margin-right: 0;
  }

  h4 {
    text-align: center;
    line-height: 50px;
  }

  .list_img_zl {
    width: 100%;
    height: 150px;
    overflow: hidden;
    flex: 1;
    display: flex;
    justify-content: center;

    img {
      height: 100%;
    }
  }

  .list_cont_body_p {
    height: 56px;
    padding: 0 16px 10px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .list_cont_body_zl {
    flex: 5;
    padding: 0 16px 10px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}


.tabBox {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0 20px 0;
  display: flex;

  .listBox {
    overflow: hidden;
    padding: 10px 0;
    cursor: pointer;

    .leftBox {
      float: left;
      width: 24%;
      height: 170px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      float: left;
      margin-left: 2%;
      width: 74%;
      font-size: 14px;

      .title {
        padding: 10px 0;
        font-size: 20px;
        color: #333;
        font-weight: 500;
      }

      .content {
        overflow: hidden;
        margin: 10px 0;
        color: #666;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .time {
        padding: 10px 0;
        color: #999;
      }
    }
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab) {
    font-size: 14px;
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active) {
    color: #fff;
    background-color: #1890ff;
  }

  .activeLeftImg {
    width: 184px;
    margin-right: 16px;
    position: relative;

    .body_img_btn {
      cursor: pointer;
      position: absolute;
      bottom: 20px;
      left: 15%;
      font-size: 13px;
      color: #ffffff;
      font-weight: 600;
      padding: 10px 20px;
      border: 2px solid rgba(0, 0, 0, 0);

      &:hover {
        border: 2px solid #ffffff;
        transition: all 0.3s ease 0s;
      }

    }

    .red {
      background: #f34949;
    }

    .porpo {
      background: #616aeb;
    }

    .blue {
      background: #2fb5f4;
    }

    img {
      width: 100%;
    }
  }

  .activityContent {
    flex: 1;

    .activityLi {
      border: 1px solid #ebebeb;
      float: left;
      width: 238px;
      margin: 0 0 16px;
      margin-right: 16px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .activityImg {
        width: 100%;
        height: 180px;
      }

      .activityInfoTitle {
        padding: 15px 0;
        font-size: 16px;
        color: #333;
      }

      .activityInfoTime {
        overflow: hidden;
        padding: 5px 0;
        font-size: 14px;
        position: relative;
        color: #8b8b8b;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;

        span {
          position: absolute;
          right: 0
        }
      }

      .activityInfoAddress {
        overflow: hidden;
        padding: 5px 10px 20px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .activityLi:hover {
      //box-shadow: 5px 5px 10px 10px #f1f1f1;
      //transition: all 0.5s ease 0s;

      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;
      //.activityInfoTitle {
      //	color: #fff;
      //	background-color: #2162e4;
      //
      //}
      //
      //.activityInfoTime {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
      //
      //.activityInfoAddress {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
    }
  }
}</style>